module.exports = __webpack_public_path__ + "img/dispatchedAttach.be23db54.svg";